import { NgModule } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { CurrencyInputModule } from '../../../../shared/currency-input/currency-input.module';
import { FieldErrorDisplayModule } from '../../../../shared/field-error-display/field-error-display.module';
import { SharedModule } from '../../../../shared/shared.module';
import { BankAccountSelectorModule } from '../../../shared/bank-account-selector/bank-account-selector.module';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { StringValidatorsModule } from '../../../../../directives/validators/string/string-validators.module';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NotificationBarModule } from '../../../shared/notification-bar/notification-bar.module';
import { ButtonModule } from '../../../../shared/button/button.module';
import { EditPaymentDialogComponent } from 'app/components/app-layout/payments/incoming-payments/edit-payment-dialog/edit-payment-dialog.component';

@NgModule({
    imports: [
        SharedModule,
        CurrencyInputModule,
        LegfiDatePipeModule,
        LegfiCurrencyPipeModule,
        StringValidatorsModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatMenuModule,
        MatButtonModule,
        BankAccountSelectorModule,
        NotificationBarModule,
        ButtonModule,
        FieldErrorDisplayModule,
        MatSortModule,
    ],
    exports: [EditPaymentDialogComponent],
    declarations: [EditPaymentDialogComponent],
})
export class EditPaymentDialogModule
{
}
